import { useTranslation } from 'react-i18next';
import LiveTv from '@jwp/ott-theme/assets/icons/live_tv.svg?react';
import List from '@jwp/ott-theme/assets/icons/list.svg?react';
import type { EpgView } from '@jwp/ott-common/types/epg';

import Select from '../Select/Select';
import ToggleGroup from '../ToggleGroup/ToggleGroup';
import Icon from '../Icon/Icon';

import styles from './EpgHeader.module.scss';

type Props = {
  title: string;
  dayOptions: { value: string; label: string }[];
  day: number;
  view: EpgView;
  onViewChange: (value: EpgView) => void;
  onDayChange: (value: string) => void;
};

const EpgHeader: React.FC<Props> = ({ title, dayOptions, day, view, onViewChange, onDayChange }) => {
  const { t } = useTranslation('epg');

  return (
    <div className={styles.epgHeader}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.container}>
        <div>
          {view === 'guide' && (
            <Select
              name="epgDay"
              className={styles.select}
              options={dayOptions}
              value={String(day)}
              label={t('select_date')}
              onChange={(event) => onDayChange(event.target.value)}
            />
          )}
        </div>
        <div>
          <ToggleGroup
            name="epgView"
            legend={t('select_view')}
            value={view}
            options={[
              { value: 'guide', label: t('guide'), icon: <Icon icon={List} /> },
              { value: 'live', label: t('live_now'), icon: <Icon icon={LiveTv} /> },
            ]}
            onChange={onViewChange}
          />
        </div>
      </div>
    </div>
  );
};

export default EpgHeader;
